// extracted by mini-css-extract-plugin
export default {"container":"section-description_container__3lz0T"};